import React, { useState } from "react";
import ScoreMemberCard from "../ScoreItem/ScoreMemberCard";
import { IRecipientModel } from "../../../../Models/Recipient";
import ModuleOverviewModal from "../../../../Pages/PartnerModules/ModuleOverviewModal";
import TaskList from "../../../Assessment/TaskList/TaskList";
import LegalModuleDescription from "../../../../Pages/PartnerModules/LegalModuleDescription";
import LegalIcon from "../../../../Images/Icons/Legal Icon.png";
import TaskModal from "../ModuleTasks/ModuleModal/TaskModal";
import { observer } from "mobx-react-lite";
import { moduleTitles } from "../../../Enums/TitleEnums"

export interface ILegalScoreCardProps {
  selectedRecipient: IRecipientModel;
  caregiverId: string;
}

const LegalScoreCard: React.FC<ILegalScoreCardProps> = ({
  selectedRecipient, caregiverId
}) => {
  const [moduleOverviewVisible, setModuleOverviewVisible] = useState(false);
  const [taskAssessmentVisible, setTaskAssessmentVisible] = useState(false);
  const [taskChecklistVisible, setTaskChecklistVisible] = useState(false);
  const [taskIndex, setTaskIndex] = useState(0);
  const [taskTitle, setTaskTitle] = useState(selectedRecipient.legalAssessment.questions[0].taskName || "");

  const setOverviewVisible = () => { setModuleOverviewVisible(true); };
  const setIndexOfTask = (idx: number) => { setTaskIndex(idx); };
  const setTitleOfTask = (title: string) => { setTaskTitle(title); }

  const questions = selectedRecipient.legalAssessment.questions;


  const renderModuleOverview = () => {
    return (
      <ModuleOverviewModal
        overviewBody={<LegalModuleDescription />}
        hideOverview={() => setModuleOverviewVisible(false)}
        tasks={questions}
        assessment={selectedRecipient.legalAssessment}
        domain={moduleTitles.LEGAL}
        taskIndex={taskIndex}
        caregiverId={caregiverId}
        selectedRecipientId={selectedRecipient.id}
        selectedRecipientName={`${selectedRecipient.firstName} ${selectedRecipient.lastName}`}
        setTaskChecklistToVisible={() => setTaskChecklistVisible(true)}
        setAssessmentToVisible={() => setTaskAssessmentVisible(true)}
        setAssessmentHidden={() => setTaskAssessmentVisible(false)}
        setTaskIndex={setIndexOfTask}
        setTaskTitle={setTitleOfTask}
      />
    );
  };

  const renderTaskModal = () => {
    return (
      <TaskModal
        hideAssessment={() => setTaskAssessmentVisible(false)}
        taskIndex={taskIndex}
        taskTitle={taskTitle}
        recipient={selectedRecipient}
        assessment={selectedRecipient.legalAssessment}
        caregiverId={caregiverId}
        selectedRecipientId={selectedRecipient.id}
        selectedRecipientName={`${selectedRecipient.firstName} ${selectedRecipient.lastName}`}
        domain={moduleTitles.LEGAL}
        setTaskTitle={setTitleOfTask}
      />
    );
  };

  const renderTaskChecklistModal = () => {
    return (
      <TaskList
        assessment={selectedRecipient.legalAssessment}
        hideTaskList={() => setTaskChecklistVisible(false)}
      />
    );
  };

  return (
    <>
      {taskChecklistVisible && renderTaskChecklistModal()}
      {taskAssessmentVisible && renderTaskModal()}
      {moduleOverviewVisible && renderModuleOverview()}
      <ScoreMemberCard
        percentComplete={selectedRecipient.legalScoreComplete}
        selectedRecipient={selectedRecipient}
        icon={LegalIcon}
        title={moduleTitles.LEGAL}
        overviewTitle="Legal/Financial Domain"
        videoLink={"undefined"}
        overviewBody={<LegalModuleDescription />}
        assessment={selectedRecipient.legalAssessment}
        tasks={[]}
        setModVisible={setOverviewVisible}
        setAssessmentVisible={setOverviewVisible}
      />
    </>
  );
};

export default observer(LegalScoreCard);
